import React from 'react'
import { SimpleMenu } from '../../components'
import { object } from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './LoginPage.styl'
import { parseQueryParams } from '../../../utils/helpers'

class LoginPage extends React.Component {

	static propTypes = {
		location: object
	}

	state = { wrongCredentials: false }

	checkFields(e) {
		if (!e.target.password.value || !e.target.username.value) {
			e.preventDefault()
			this.setState({ wrongCredentials: true })
		}
	}
	handleSubmit(e) {
		e.preventDefault()
		const data = {
			username: e.target.username.value,
			password: e.target.password.value
		}
		const { location: { search } } = this.props
		const queryParams = parseQueryParams(search)
		fetch('/api/accounts/login', {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'same-origin'
		})
			.then(r => {
				if (r.status === 500 || r.status === 401) {
					this.setState({ wrongCredentials: true })
				} else if (r.status === 200) {
					if (queryParams['redirect']) {
						window.location = queryParams['redirect']
					} else {
						window.location = '/apt/workout/daily'
					}
				}
			})
	}
	render() {
		const { wrongCredentials } = this.state
		return (
			<div>
				<SimpleMenu />
				<div className={ styles.container }>
					<div className={ styles['login-container'] }>
						<div className={ styles.title }>Login</div>
						{ wrongCredentials ? <p className={ styles.warning }>Username ou Password incorreta!</p> : null }
						<form onSubmit={ this.handleSubmit.bind(this) } method="POST" onSubmitCapture={ this.checkFields.bind(this) } className={ styles['login-form'] }>
							<div className={ styles['input-info'] }>
								<input type="email" name="username" placeholder="Username" />
							</div>
							<div className={ styles['input-info'] }>
								<input type="password" name="password" placeholder="Password" />
							</div>
							<input className={ styles.submit } type="submit" value="Entrar" />
							<span className={ styles.passwordRecovery }>Esqueceste-te da tua password? <Link to="/password_recovery">Clique aqui</Link></span>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/client/website/pages/LoginPage/LoginPage.js